(function () {
  var STORAGE_KEY = 'cdm:b2b-register:draft:v1';
  var ANALYSIS_MESSAGE = 'Cadastro recebido para análise. Nenhum acesso foi criado automaticamente neste momento.';
  var ACCESS_PENDING_MESSAGE = 'Cadastro empresarial criado. A liberação de acesso está pendente.';
  var CREATED_MESSAGE = 'Cadastro B2B criado com sucesso. Agora acesse o Portal Corporativo para continuar.';
  var REQUIRED_CREATED_IDS = ['customerId', 'companyId', 'companyLocationId', 'companyContactId'];

  function onlyDigits(value) {
    return (value || '').replace(/\D/g, '');
  }

  function maskCnpj(value) {
    var digits = onlyDigits(value).slice(0, 14);
    return digits
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }

  function maskCep(value) {
    var digits = onlyDigits(value).slice(0, 8);
    return digits.replace(/^(\d{5})(\d)/, '$1-$2');
  }

  function maskTelefone(value) {
    var digits = onlyDigits(value).slice(0, 11);

    if (digits.length <= 10) {
      return digits
        .replace(/^(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    }

    return digits
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2');
  }

  function applyMask(field) {
    var mask = field.getAttribute('data-cdm-mask');

    if (mask === 'cnpj') {
      field.value = maskCnpj(field.value);
      return;
    }

    if (mask === 'cep') {
      field.value = maskCep(field.value);
      return;
    }

    if (mask === 'telefone') {
      field.value = maskTelefone(field.value);
    }
  }

  function getFields(form) {
    return Array.prototype.slice.call(form.querySelectorAll('[data-cdm-field]'));
  }

  function getPayload(form) {
    var payload = {};

    getFields(form).forEach(function (field) {
      var key = field.getAttribute('data-cdm-field');
      if (!key) return;

      if (field.type === 'checkbox') {
        payload[key] = field.checked;
        return;
      }

      payload[key] = field.value ? field.value.trim() : '';
    });

    return payload;
  }

  function saveDraft(form) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(getPayload(form)));
    } catch (error) {
      return;
    }
  }

  function clearDraft() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      return;
    }
  }

  function restoreDraft(form) {
    var raw;
    var draft;

    try {
      raw = window.localStorage.getItem(STORAGE_KEY);
      draft = raw ? JSON.parse(raw) : null;
    } catch (error) {
      draft = null;
    }

    if (!draft) return false;

    getFields(form).forEach(function (field) {
      var key = field.getAttribute('data-cdm-field');
      if (!key || typeof draft[key] === 'undefined') return;

      if (field.type === 'checkbox') {
        field.checked = draft[key] === true;
        return;
      }

      field.value = draft[key] || '';
      applyMask(field);
    });

    return true;
  }

  function showMessage(element, message) {
    if (!element) return;

    var text = element.querySelector('p');
    if (text && message) text.textContent = message;
    element.hidden = false;
    element.focus();
  }

  function getWorkerErrorMessage(body, fallbackMessage) {
    var code = body && body.code ? String(body.code).toUpperCase() : '';

    if (code === 'DUPLICATE_EMAIL') {
      return 'Este e-mail ja possui cadastro. Use outro e-mail ou fale com o time Cafe do Mercado para ativar o acesso B2B.';
    }

    if (code === 'DUPLICATE_CNPJ') {
      return 'Este CNPJ ja possui cadastro. Fale com o time Cafe do Mercado para ativar ou revisar o acesso B2B.';
    }

    if (body && body.publicMessage) return String(body.publicMessage);
    if (body && body.safeMessage) return String(body.safeMessage);
    if (body && body.message) return String(body.message);

    return fallbackMessage;
  }

  function getCreatedIds(body) {
    if (!body) return {};

    if (body.createdIds && typeof body.createdIds === 'object') {
      return body.createdIds;
    }

    return body;
  }

  function hasRequiredCreatedIds(body) {
    var createdIds = getCreatedIds(body);

    return REQUIRED_CREATED_IDS.every(function (key) {
      return Boolean(createdIds[key]);
    });
  }

  function hasShopifyCreationResponse(body) {
    return Boolean(
      body
        && body.mode !== 'dry_run'
        && body.writeMode === true
        && hasRequiredCreatedIds(body)
        && (Boolean(getCreatedIds(body).catalogId) || body.catalogAssigned === true)
    );
  }

  function hasAuth0CreationResponse(body) {
    var createdIds = getCreatedIds(body);

    return Boolean(
      body
        && (
          body.auth0UserCreated === true
          || body.auth0UserLinked === true
          || body.auth0UserReused === true
          || Boolean(createdIds.auth0UserId)
        )
    );
  }

  function isConfirmedCreationResponse(body) {
    return hasShopifyCreationResponse(body) && hasAuth0CreationResponse(body);
  }

  function isAccessPendingResponse(body) {
    return hasShopifyCreationResponse(body) && !hasAuth0CreationResponse(body);
  }

  function hideMessage(element) {
    if (element) element.hidden = true;
  }

  function setLoading(form, isLoading) {
    var button = form.querySelector('[data-cdm-submit]');
    if (!button) return;

    button.disabled = isLoading;
    button.textContent = isLoading ? 'Enviando...' : 'Criar acesso B2B';
  }

  function showSuccessScreen(form, successScreen, title, message) {
    form.hidden = true;

    if (successScreen) {
      var heading = successScreen.querySelector('h2');
      var text = successScreen.querySelector('p');

      if (heading && title) heading.textContent = title;
      if (text && message) text.textContent = message;
      successScreen.hidden = false;
      successScreen.focus();
    }
  }

  function setFieldValidity(field, force) {
    var invalid = force ? !field.checkValidity() : false;
    field.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    return !invalid;
  }

  function clearInvalidState(scope) {
    scope.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
      field.setAttribute('aria-invalid', 'false');
    });
  }

  function stepFields(step) {
    return Array.prototype.slice.call(step.querySelectorAll('input, select, textarea'))
      .filter(function (field) {
        return field.type !== 'hidden' && field.getAttribute('data-cdm-field') !== 'website';
      });
  }

  function validateStep(step) {
    var fields = stepFields(step);
    var firstInvalid = null;

    fields.forEach(function (field) {
      var valid = field.checkValidity();
      field.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid && !firstInvalid) firstInvalid = field;
    });

    if (firstInvalid) {
      firstInvalid.focus();
      return false;
    }

    return true;
  }

  function updateSummary(form, sourcePayload) {
    var payload = sourcePayload || getPayload(form);
    var summary = {
      email: payload.email || '-',
      cnpj: payload.cnpj || '-',
      razao_social: payload.razao_social || '-',
      cidade_uf: payload.cidade || payload.uf ? [payload.cidade, payload.uf].filter(Boolean).join('/') : '-',
      responsavel_nome: payload.responsavel_nome || '-',
      tipo_cliente: payload.tipo_cliente || '-'
    };

    Object.keys(summary).forEach(function (key) {
      var element = form.querySelector('[data-cdm-summary-field="' + key + '"]');
      if (element) element.textContent = summary[key];
    });
  }

  function initMasks(form) {
    form.querySelectorAll('[data-cdm-mask]').forEach(function (field) {
      field.addEventListener('input', function () {
        applyMask(field);
        setFieldValidity(field, false);
        saveDraft(form);
      });

      field.addEventListener('blur', function () {
        applyMask(field);
        if (field.hasAttribute('required') && field.value) setFieldValidity(field, true);
        saveDraft(form);
      });
    });
  }

  function initDraftSaving(form) {
    getFields(form).forEach(function (field) {
      if (field.getAttribute('data-cdm-field') === 'website') return;

      field.addEventListener('input', function () {
        setFieldValidity(field, false);
        saveDraft(form);
        updateSummary(form);
      });

      field.addEventListener('change', function () {
        setFieldValidity(field, false);
        saveDraft(form);
        updateSummary(form);
      });
    });
  }

  function validateAllSteps(steps, goToStep) {
    var allValid = true;
    var firstInvalidStep = -1;

    steps.forEach(function (step, index) {
      stepFields(step).forEach(function (field) {
        var valid = field.checkValidity();
        field.setAttribute('aria-invalid', valid ? 'false' : 'true');

        if (!valid && allValid) {
          allValid = false;
          firstInvalidStep = index;
        }
      });
    });

    if (!allValid && firstInvalidStep >= 0) {
      goToStep(firstInvalidStep);
    }

    return allValid;
  }

  function initForm(form) {
    var endpoint = form.getAttribute('data-endpoint');
    var mockMode = form.getAttribute('data-mock-mode') === 'true';
    var successMessage = form.getAttribute('data-success-message');
    var errorMessage = form.getAttribute('data-error-message');
    var successBox = form.querySelector('[data-cdm-form-success]');
    var errorBox = form.querySelector('[data-cdm-form-error]');
    var card = form.closest('.cdm-b2b-register__card');
    var successScreen = card ? card.querySelector('[data-cdm-success-screen]') : null;
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-cdm-step]'));
    var indicators = Array.prototype.slice.call(form.querySelectorAll('[data-cdm-step-indicator]'));
    var nextButton = form.querySelector('[data-cdm-next-step]');
    var prevButton = form.querySelector('[data-cdm-prev-step]');
    var submitButton = form.querySelector('[data-cdm-submit]');
    var progressBar = form.querySelector('[data-cdm-progress-bar]');
    var stepCounter = form.querySelector('[data-cdm-step-counter]');
    var stepTitle = form.querySelector('[data-cdm-step-title]');
    var currentStep = 0;

    function goToStep(index) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach(function (step, stepIndex) {
        var isActive = stepIndex === currentStep;
        step.hidden = !isActive;
        step.classList.toggle('is-active', isActive);
      });

      indicators.forEach(function (indicator, indicatorIndex) {
        indicator.classList.toggle('is-active', indicatorIndex === currentStep);
        indicator.classList.toggle('is-complete', indicatorIndex < currentStep);
      });

      if (progressBar) progressBar.style.width = (((currentStep + 1) / steps.length) * 100) + '%';
      if (stepCounter) stepCounter.textContent = 'Etapa ' + (currentStep + 1) + ' de ' + steps.length;
      if (stepTitle) stepTitle.textContent = steps[currentStep].getAttribute('data-step-label') || '';

      if (prevButton) prevButton.hidden = currentStep === 0;
      if (nextButton) nextButton.hidden = currentStep === steps.length - 1;
      if (submitButton) submitButton.hidden = currentStep !== steps.length - 1;

      hideMessage(errorBox);
      if (currentStep === steps.length - 1) updateSummary(form);
    }

    initMasks(form);
    initDraftSaving(form);
    restoreDraft(form);
    clearInvalidState(form);
    updateSummary(form);
    goToStep(0);

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        hideMessage(successBox);
        hideMessage(errorBox);

        if (!validateStep(steps[currentStep])) {
          showMessage(errorBox, 'Preencha os campos obrigatorios desta etapa para continuar.');
          return;
        }

        saveDraft(form);
        goToStep(currentStep + 1);
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        hideMessage(successBox);
        hideMessage(errorBox);
        saveDraft(form);
        goToStep(currentStep - 1);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideMessage(successBox);
      hideMessage(errorBox);

      if (!validateAllSteps(steps, goToStep)) {
        showMessage(errorBox, 'Preencha os campos obrigatorios para criar o acesso B2B.');
        return;
      }

      var payload = getPayload(form);
      if (payload.website) {
        form.reset();
        clearDraft();
        clearInvalidState(form);
        updateSummary(form);
        showSuccessScreen(form, successScreen, 'Cadastro recebido', ANALYSIS_MESSAGE);
        return;
      }

      if (mockMode || !endpoint) {
        form.reset();
        clearDraft();
        clearInvalidState(form);
        updateSummary(form);
        showMessage(successBox, ANALYSIS_MESSAGE);
        return;
      }

      setLoading(form, true);

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'omit',
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () {
            return {};
          }).then(function (body) {
            if ((!response.ok || !body.ok) && !isAccessPendingResponse(body)) {
              throw new Error(getWorkerErrorMessage(body, errorMessage));
            }
            return body;
          });
        })
        .then(function (body) {
          var submittedPayload = payload;
          clearInvalidState(form);
          updateSummary(form, submittedPayload);

          if (isConfirmedCreationResponse(body)) {
            form.reset();
            clearDraft();
            showSuccessScreen(form, successScreen, 'Cadastro B2B criado com sucesso', CREATED_MESSAGE);
            return;
          }

          if (isAccessPendingResponse(body)) {
            form.reset();
            clearDraft();
            showSuccessScreen(form, successScreen, 'Liberação de acesso pendente', ACCESS_PENDING_MESSAGE);
            return;
          }

          if (body && body.mode === 'dry_run') {
            showMessage(successBox, ANALYSIS_MESSAGE);
            return;
          }

          showMessage(successBox, ANALYSIS_MESSAGE);
        })
        .catch(function (error) {
          showMessage(errorBox, error.message || errorMessage);
        })
        .finally(function () {
          setLoading(form, false);
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cdm-b2b-register-form]').forEach(initForm);
  });
}());
